import routerOptions0 from "/usr/src/app/content/n3-treatments-f80220fd-37c5-4796-87e4-e05a219275ac/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}